// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__1CbDS","link":"footer_link__rNuqK","wechat":"footer_wechat__1v3Yx","wechatImg":"footer_wechatImg__DLl0a"};